import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Container, Form, Button, Row, Col, Badge  } from 'react-bootstrap';
import { State, City } from 'country-state-city';
import { Card } from 'react-bootstrap';
import { PencilSquare } from 'react-bootstrap-icons'; // Optional icon
import './ProfileCard.css'; //
import {   FaUser, FaEnvelope, FaPhone, FaBuilding, FaMapMarkerAlt,
  FaCity, FaIdCard, FaFileInvoice, FaEdit, 
  FaIndustry,
  FaMapMarkedAlt,
  FaFingerprint,
  FaTimesCircle,
  FaCheckCircle} from 'react-icons/fa';

export default function Profile() {
 const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedStateCode, setSelectedStateCode] = useState('');

  const [isEditing, setIsEditing] = useState(false);

  // Load Indian states on component mount
  useEffect(() => {
    const allStates = State.getStatesOfCountry('IN');
    setStates(allStates);
  }, []);

  // Load cities when selectedStateCode changes
  useEffect(() => {
    if (selectedStateCode) {
      const allCities = City.getCitiesOfState('IN', selectedStateCode);
      setCities(allCities);
    } else {
      setCities([]);
    }
  }, [selectedStateCode]);


const [categories, setCategories] = useState([]);

useEffect(() => {
  axios.get('https://vyaparapi.emedha.in/api/auth/business-categories')
    .then(res => setCategories(res.data))
    .catch(() => alert('Failed to load categories'));
}, []);


useEffect(() => {
  const indianStates = State.getStatesOfCountry('IN');
  setStates(indianStates);
}, []);




  const [formData, setFormData] = useState({
    user_id: '',
    name: '',
    email: '',
    mobile: '',
    business_category: '',
    state: '',
    city: '',
    gst_number: '',
    aadhar_number: '',
  });

  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    if (user) {
      axios.get(`https://vyaparapi.emedha.in/api/auth/api/users/${user.id}`).then(res => {
        setFormData(prev => ({
          ...prev,
          user_id: user.id,
          name: res.data.name,
          email: res.data.email,
          mobile: res.data.mobile,
        }));
      });

axios.get(`https://vyaparapi.emedha.in/api/auth/api/seller-profile/${user.id}`).then(res => {
  if (res.data) {
        sessionStorage.setItem("business_category", res.data.business_category);
    setFormData(prev => ({
      ...prev,
      ...res.data
    }));
    setSelectedStateCode(
      State.getStatesOfCountry('IN').find(s => s.name === res.data.state)?.isoCode || ''
    );
    const cityList = City.getCitiesOfState('IN', selectedStateCode);
    setCities(cityList);
    setIsEditing(false); // show card view by default
  } else {
    setIsEditing(true); // no profile, show form
  }
});

    }
  }, []);

  const handleChange = e => {
    const { name, value } = e.target;

  if (name === 'state') {
    const selected = states.find(s => s.name === value);
    setSelectedStateCode(selected?.isoCode || '');
    setFormData(prev => ({ ...prev, state: value, city: '' }));

    const citiesList = City.getCitiesOfState('IN', selected?.isoCode);
    setCities(citiesList);
  } else {
    setFormData(prev => ({ ...prev, [name]: value }));
  }
    
  };

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const res = await axios.post('https://vyaparapi.emedha.in/api/auth/api/buyer-profile', formData);
      alert(res.data.message);
      setIsEditing(false);
    } catch (err) {
      alert('Failed to save profile');
    }
  };

  return (
    <Container>
 
       {!isEditing ? 
 (
   <Card className="profile-card shadow-lg p-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="profile-title text-center">Profile Information</h4>
        <FaEdit
          size={24}
          className="edit-icon"
          onClick={() => setIsEditing(true)}
          title="Edit Profile"
        />
      </div>

      <Row>
        <Col md={6}>
          <div className="profile-row">
            <FaUser className="icon" />
            <span className="label">Name</span>
            <Badge bg="light" text="dark" className="value-badge">{formData.name}</Badge>
          </div>

          <div className="profile-row">
            <FaEnvelope className="icon" />
            <span className="label">Email</span>
            <Badge bg="light" text="dark" className="value-badge">{formData.email}</Badge>
          </div>

          <div className="profile-row">
            <FaPhone className="icon" />
            <span className="label">Mobile</span>
            <Badge bg="light" text="dark" className="value-badge">{formData.mobile}</Badge>
          </div>

<div className="profile-row d-flex align-items-center mb-3">
  <FaFileInvoice className="icon me-1 " size={18} />
  <span className="label fw-semibold me-1">GST No:</span>
  <Badge bg="light" text="dark" className="value-badge me-2">
    {formData.gst_number || 'N/A'}
  </Badge>
  {formData.gst_verify ? (
    <Badge bg="success" className="d-flex align-items-center">
      <FaCheckCircle className="me-1" /> Verified
    </Badge>
  ) : (
    <Badge bg="danger" className="d-flex align-items-center">
      <FaTimesCircle className="me-1" /> Not Verified
    </Badge>
  )}
</div>
        </Col>

        <Col md={6}>
          <div className="profile-row">
            <FaBuilding className="icon" />
            <span className="label">Category</span>
            <Badge bg="light" text="dark" className="value-badge">{formData.business_category}</Badge>
          </div>

          <div className="profile-row">
            <FaMapMarkerAlt className="icon" />
            <span className="label">State</span>
            <Badge bg="light" text="dark" className="value-badge">{formData.state}</Badge>
          </div>

          <div className="profile-row">
            <FaCity className="icon" />
            <span className="label">City</span>
            <Badge bg="light" text="dark" className="value-badge">{formData.city}</Badge>
          </div>

<div className="profile-row d-flex align-items-center mb-3">
  <FaIdCard className="icon me-1 " size={18} />
  <span className="label fw-semibold me-2">Aadhar:</span>
  <Badge bg="light" text="dark" className="value-badge me-2">
    {formData.aadhar_number || 'N/A'}
  </Badge>
  {formData.aadhar_verify ? (
    <Badge bg="success" className="d-flex align-items-center">
      <FaCheckCircle className="me-1" /> Verified
    </Badge>
  ) : (
    <Badge bg="danger" className="d-flex align-items-center">
      <FaTimesCircle className="me-1" /> Not Verified
    </Badge>
  )}
</div>
        </Col>
      </Row>
    </Card>

    ) : (
        <Container>
  <Row className="justify-content-center">
    <Col md={9}>

<Card className="shadow-md p-4 mb-4">
  <h4 className="text-center mb-4 text-primary fw-bold">Edit Profile</h4>
  <Form onSubmit={handleSubmit}>
    <Row>
      <Col md={6}>
        <Form.Group controlId="name" className="mb-3">
          <Form.Label><FaUser className="me-2 text-secondary" />Name *</Form.Label>
          <Form.Control
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter your name"
            required
          />
        </Form.Group>
      </Col>

      <Col md={6}>
        <Form.Group controlId="email" className="mb-3">
          <Form.Label><FaEnvelope className="me-2 text-secondary" />Email *</Form.Label>
          <Form.Control
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter your email"
            required
          />
        </Form.Group>
      </Col>
    </Row>

    <Row>
      <Col md={6}>
        <Form.Group controlId="mobile" className="mb-3">
          <Form.Label><FaPhone className="me-2 text-secondary" />Mobile *</Form.Label>
          <Form.Control
            type="text"
            name="mobile"
            value={formData.mobile}
            onChange={handleChange}
            placeholder="Enter your mobile number"
            required
          />
        </Form.Group>
      </Col>

      <Col md={6}>
        <Form.Group controlId="business_category" className="mb-3">
          <Form.Label><FaIndustry className="me-2 text-secondary" />Business Category *</Form.Label>
          <Form.Select
            name="business_category"
            value={formData.business_category}
            onChange={handleChange}
            required
          >
            <option value="">Select Category</option>
            {categories.map((cat) => (
              <option key={cat.id} value={cat.name}>
                {cat.name}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </Col>
    </Row>

    <Row>
      <Col md={6}>
        <Form.Group controlId="state" className="mb-3">
          <Form.Label><FaMapMarkedAlt className="me-2 text-secondary" />State *</Form.Label>
          <Form.Select
            name="state"
            value={formData.state}
            onChange={handleChange}
            required
          >
            <option value="">Select State</option>
            {states.map((state) => (
              <option key={state.isoCode} value={state.name}>
                {state.name}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </Col>

      <Col md={6}>
        <Form.Group controlId="city" className="mb-3">
          <Form.Label><FaCity className="me-2 text-secondary" />City *</Form.Label>
          <Form.Select
            name="city"
            value={formData.city}
            onChange={handleChange}
            required
          >
            <option value="">Select City</option>
            {cities.map((city) => (
              <option key={city.name} value={city.name}>
                {city.name}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </Col>
    </Row>

    <Row>
      <Col md={6}>
        <Form.Group controlId="gst_number" className="mb-3">
          <Form.Label><FaIdCard className="me-2 text-secondary" />GST Number</Form.Label>
          <Form.Control
            type="text"
            name="gst_number"
            value={formData.gst_number}
            onChange={handleChange}
            placeholder="Enter GST Number"
          />
        </Form.Group>
      </Col>

      <Col md={6}>
        <Form.Group controlId="aadhar_number" className="mb-3">
          <Form.Label><FaFingerprint className="me-2 text-secondary" />Aadhar Number</Form.Label>
          <Form.Control
            type="text"
            name="aadhar_number"
            value={formData.aadhar_number}
            onChange={handleChange}
            placeholder="Enter Aadhar Number"
          />
        </Form.Group>
      </Col>
    </Row>

    <div className="text-center mt-4">
      <Button variant="primary" type="submit" className="px-5 py-2 rounded-3">
        💾 Save Profile
      </Button>
    </div>
  </Form>
</Card>
  </Col>
  </Row>
</Container>
    )}
    </Container>
  );
}
